var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var CommonUtils = require('../../utils/common-utils.js');
var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var SetInitialViewModalView = Marionette.View.extend({
    template: require('../../templates/persons/set-initial-view.html'),

    regions: {
        personsSelect: '#persons-container',
    },

    ui: {
        modal: '#set-initial-view-modal',
        save: '#save'
    },

    events: {
        'click @ui.save': 'onSave'
    },

    childViewEvents: {
        'suggestor:selected:person': 'personChanged'
    },

    templateContext: function () {
        var that = this;
        return {}
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
        this.selectedPerson = null;
        this.initialViewUrl = null;
    },

    onRender: function () {
        var that = this;
        that.renderPersonSelectView(that.selectedPerson);
    },

    renderPersonSelectView: function (person) {
        var that = this;

        that.showChildView('personsSelect', new RemoteSuggesterView({
            maxNumberOfElements: 20,
            url: '/api/person/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Select Person",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'person',
            defaultSelected: person
        }));
    },
    onSave: function () {
        var that = this;
        console.log(that.selectedPerson);
        console.log(that.initialViewUrl);
        $.ajax({
            type: "POST",
            url: '/api/person/initial-url?personId=' + that.selectedPerson,
            contentType: 'text/plain',
            data: this.initialViewUrl,
            statusCode: {
                200: function () {
                    that.hide();
                    $.notify({
                        message: 'Initial View was set successfully'
                    }, {
                        type: 'success',
                        z_index: 2000
                    });
                }
            },
            error: function (e) {
                if (e.status == 401) {
                    that.hide();
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    show: function (initialViewUrl) {
        this.initialViewUrl = initialViewUrl;
        this.validate();
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    enableSave: function () {
        this.ui.save.removeAttr('disabled');
    },

    disableSave: function () {
        this.ui.save.attr('disabled', true);
    },

    validate: function () {
        if (this.selectedPerson && this.initialViewUrl)
            this.enableSave();
        else
            this.disableSave();
    },

    personChanged: function (id) {
        this.selectedPerson = id;
        this.validate();
    },
});

module.exports = SetInitialViewModalView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/set-initial-view.js
// module id = 188
// module chunks = 0